var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isReady
    ? _c("div", { staticStyle: { padding: "20px" } }, [
        _c("div", { staticClass: "text-size-20" }, [
          _vm._v(
            "\n    商品の需要予測に基づいて、FBAへの納品をご提案します。Amazonが算出した値を使用しています。\n  "
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "panel-body" },
          [
            _vm.cantViewContent ? _c("premium-modal") : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "filter-container" }, [
              _c("div", { staticClass: "flexbox gap-20" }, [
                _c("div", { staticClass: "filter-keyword" }, [
                  _c("span", { staticClass: "search-icon-left" }, [
                    _vm._v("🔎")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.keyword,
                        expression: "keyword"
                      }
                    ],
                    staticClass: "search-input",
                    attrs: {
                      type: "text",
                      placeholder: "ASIN、SKU、FNSKU、商品名",
                      autocomplete: "off"
                    },
                    domProps: { value: _vm.keyword },
                    on: {
                      keyup: function($event) {
                        if (
                          !("button" in $event) &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleFilter($event)
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.keyword = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "clear-search",
                      on: {
                        click: function($event) {
                          _vm.keyword = ""
                        }
                      }
                    },
                    [_vm._v("✕")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "filter-actions" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary mr-r-10",
                      attrs: { type: "button" },
                      on: { click: _vm.handleFilter }
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-search",
                        attrs: { "aria-hidden": "true" }
                      }),
                      _vm._v(" 検索\n          ")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn",
                      attrs: { type: "button" },
                      on: { click: _vm.resetFilters }
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-undo",
                        attrs: { "aria-hidden": "true" }
                      }),
                      _vm._v(" すべてクリア\n          ")
                    ]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "table-toolbar" }, [
              _c("div", { staticClass: "toolbar-left" }, [
                _c("span", { staticClass: "snapshot-date" }, [
                  _vm._v(_vm._s(_vm.snapshotDate) + " "),
                  _c("span", { staticClass: "text-size-14" }, [
                    _vm._v("時点の情報")
                  ])
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "snapshot-note" }, [
                  _vm._v(
                    "在庫数、納品数の目安は最新のデータとは異なる可能性があるのでご注意ください。"
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "toolbar-right" },
                [
                  _c("single-select", {
                    attrs: { items: _vm.sortOptions, placeholder: "並び替え:" },
                    model: {
                      value: _vm.sortKey,
                      callback: function($$v) {
                        _vm.sortKey = $$v
                      },
                      expression: "sortKey"
                    }
                  }),
                  _vm._v(" "),
                  _c("pagination-next-page", {
                    attrs: {
                      totalPage: _vm.totalPage,
                      currentPage: _vm.currentPage,
                      paginationStorageKey: _vm.paginationStorageKey
                    },
                    on: {
                      updateCurrentPage: function($event) {
                        _vm.currentPage = $event
                      }
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "table-wrapper" }, [
              _c("table", { staticClass: "table table-bordered fba-table" }, [
                _c("thead", [
                  _c("tr", { staticClass: "header-row" }, [
                    _c("th", { staticClass: "col-product" }),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "col-stockcrew sortable-th",
                        on: {
                          click: function($event) {
                            _vm.toggleHeaderSort("stockcrewAvailableStock")
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "th-group" }, [
                          _vm._v("STOCKCREW")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "th-sub" }, [
                          _vm._v(
                            "\n                販売可能在庫数\n                "
                          ),
                          _vm.headerSort.field === "stockcrewAvailableStock"
                            ? _c("i", {
                                class:
                                  _vm.headerSort.dir === "asc"
                                    ? "fa fa-sort-asc"
                                    : "fa fa-sort-desc",
                                attrs: { "aria-hidden": "true" }
                              })
                            : _vm._e()
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "col-amazon sortable-th",
                        on: {
                          click: function($event) {
                            _vm.toggleHeaderSort("amazonAvailableStock")
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "th-group" }, [
                          _vm._v("Amazon")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "th-sub" }, [
                          _vm._v(
                            "\n                販売可能在庫数\n                "
                          ),
                          _vm.headerSort.field === "amazonAvailableStock"
                            ? _c("i", {
                                class:
                                  _vm.headerSort.dir === "asc"
                                    ? "fa fa-sort-asc"
                                    : "fa fa-sort-desc",
                                attrs: { "aria-hidden": "true" }
                              })
                            : _vm._e()
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "col-amazon sortable-th",
                        on: {
                          click: function($event) {
                            _vm.toggleHeaderSort("amazonStockoutDate")
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "th-group" }, [
                          _vm._v("Amazon")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "th-sub" }, [
                          _vm._v(
                            "\n                在庫がなくなる推定日\n                "
                          ),
                          _vm.headerSort.field === "amazonStockoutDate"
                            ? _c("i", {
                                class:
                                  _vm.headerSort.dir === "asc"
                                    ? "fa fa-sort-asc"
                                    : "fa fa-sort-desc",
                                attrs: { "aria-hidden": "true" }
                              })
                            : _vm._e()
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "col-amazon sortable-th",
                        on: {
                          click: function($event) {
                            _vm.toggleHeaderSort("amazonAdditionalQty")
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "th-group" }, [
                          _vm._v("Amazon")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "th-sub" }, [
                          _vm._v(
                            "\n                追加納品数の目安\n                "
                          ),
                          _vm.headerSort.field === "amazonAdditionalQty"
                            ? _c("i", {
                                class:
                                  _vm.headerSort.dir === "asc"
                                    ? "fa fa-sort-asc"
                                    : "fa fa-sort-desc",
                                attrs: { "aria-hidden": "true" }
                              })
                            : _vm._e()
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "col-amazon sortable-th",
                        on: {
                          click: function($event) {
                            _vm.toggleHeaderSort("amazonShipmentDate")
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "th-group" }, [
                          _vm._v("Amazon")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "th-sub" }, [
                          _vm._v(
                            "\n                納品(算出)の目安日\n                "
                          ),
                          _vm.headerSort.field === "amazonShipmentDate"
                            ? _c("i", {
                                class:
                                  _vm.headerSort.dir === "asc"
                                    ? "fa fa-sort-asc"
                                    : "fa fa-sort-desc",
                                attrs: { "aria-hidden": "true" }
                              })
                            : _vm._e()
                        ])
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  [
                    _vm.products.length === 0
                      ? _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "text-center no-data",
                              attrs: { colspan: "6" }
                            },
                            [_vm._v("データが見つかりません。")]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.products, function(item, index) {
                      return _c("tr", { key: index }, [
                        _c("td", { staticClass: "col-product" }, [
                          _c("div", { staticClass: "flexbox gap-10 no-wrap" }, [
                            item.image
                              ? _c("img", {
                                  staticClass: "product-img",
                                  attrs: { src: item.image, alt: "" }
                                })
                              : _c("div", {
                                  staticClass: "product-img-placeholder"
                                }),
                            _vm._v(" "),
                            _c("div", { staticClass: "product-info" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "product-name text--underline",
                                  attrs: {
                                    href:
                                      "https://www.amazon.co.jp/gp/offer-listing/" +
                                      item.asin,
                                    target: "_blank"
                                  }
                                },
                                [_vm._v(_vm._s(item.productName))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "flexbox product-meta" },
                                [
                                  _c("span", { staticClass: "meta-pair" }, [
                                    _c("span", { staticClass: "meta-label" }, [
                                      _vm._v("SKU：")
                                    ]),
                                    _c("span", { staticClass: "meta-tag" }, [
                                      _vm._v(_vm._s(item.sku))
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "meta-pair" }, [
                                    _c("span", { staticClass: "meta-label" }, [
                                      _vm._v("ASIN：")
                                    ]),
                                    _c("span", { staticClass: "meta-tag" }, [
                                      _vm._v(_vm._s(item.asin))
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "meta-pair" }, [
                                    _c("span", { staticClass: "meta-label" }, [
                                      _vm._v("FNSKU：")
                                    ]),
                                    _c("span", { staticClass: "meta-tag" }, [
                                      _vm._v(_vm._s(item.fnsku))
                                    ])
                                  ])
                                ]
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "col-stockcrew cell-with-icon" },
                          [
                            _c("img", {
                              staticClass: "img-responsive sc-image cell-icon",
                              attrs: {
                                src: _vm.iconUrls["salmonSc"],
                                alt: "STOCKCREW"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "qty" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.formatNumber(item.stockcrewAvailableStock)
                                ) + " 個"
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: {
                                  content: _vm.inboundTooltip(
                                    item.amazonInboundQty
                                  ),
                                  html: true
                                },
                                expression:
                                  "{ content: inboundTooltip(item.amazonInboundQty), html: true }"
                              }
                            ],
                            staticClass: "col-amazon-data cell-with-icon"
                          },
                          [
                            _c("img", {
                              staticClass:
                                "img-responsive amazon-image cell-icon",
                              attrs: {
                                src: _vm.iconUrls["Amazon"],
                                alt: "Amazon"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "qty" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.formatNumber(item.amazonAvailableStock)
                                ) + " 個"
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "col-amazon-data text-center" },
                          [
                            item.amazonStockoutDate
                              ? _c(
                                  "span",
                                  {
                                    class: {
                                      "text-danger": _vm.isNearDate(
                                        item.amazonStockoutDate
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(item.amazonStockoutDate) +
                                        "\n              "
                                    )
                                  ]
                                )
                              : _c("span", { staticClass: "text-muted" }, [
                                  _vm._v("-")
                                ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: {
                                  content: _vm.salesHistoryTooltip(item),
                                  html: true
                                },
                                expression:
                                  "{ content: salesHistoryTooltip(item), html: true }"
                              }
                            ],
                            staticClass: "col-amazon-data text-center",
                            class: _vm.getAdditionalQtyClass(
                              item.amazonAdditionalQty
                            )
                          },
                          [
                            item.amazonAdditionalQty != null
                              ? _c("span", [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        item.amazonAdditionalQty > 0 ? "+" : ""
                                      ) +
                                      "\n                " +
                                      _vm._s(
                                        _vm.formatNumber(
                                          item.amazonAdditionalQty
                                        )
                                      ) +
                                      " 個\n              "
                                  )
                                ])
                              : _c("span", { staticClass: "text-muted" }, [
                                  _vm._v("-")
                                ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "col-amazon-data text-center",
                            class: _vm.getAdditionalQtyClass(
                              item.amazonAdditionalQty
                            )
                          },
                          [
                            item.amazonShipmentDate
                              ? _c(
                                  "span",
                                  {
                                    class: {
                                      "text-danger": _vm.isNearDate(
                                        item.amazonShipmentDate
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(item.amazonShipmentDate) +
                                        "\n              "
                                    )
                                  ]
                                )
                              : _c("span", { staticClass: "text-muted" }, [
                                  _vm._v("-")
                                ])
                          ]
                        )
                      ])
                    })
                  ],
                  2
                )
              ])
            ])
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-daa9fc98", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-daa9fc98","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/salemonAgent/FbaProductSales.vue
// module id = null
// module chunks = 